const pubCompanyRouter = [
    
    /* 화면명 : 회사 분류체계관리 ASIS  : MCP_CL_001  */
    {
        path: "/publish/cp/MCP_CL_001", 
        name : 'PUB_MCP_CL_001',
        component: () => import('@/views/publish/cp/MCP_CL_001.vue')
    },

    {
        path: "/publish/cp/MCP_CL_002", 
        name : 'PUB_MCP_CL_002',
        component: () => import('@/views/publish/cp/MCP_CL_002.vue')
    },
    
    {
        path: "/publish/cp/MCP_CL_003", 
        name : 'PUB_MCP_CL_003',
        component: () => import('@/views/publish/cp/MCP_CL_003.vue')
    },
    
    {
        path: "/publish/cp/MCP_CR_001", 
        name : 'PUB_MCP_CR_001',
        component: () => import('@/views/publish/cp/MCP_CR_001.vue')
    },
    
    {
        path: "/publish/cp/MCP_CR_002", 
        name : 'PUB_MCP_CR_002',
        component: () => import('@/views/publish/cp/MCP_CR_002.vue')
    },
    
    {
        path: "/publish/cp/MCP_CR_003", 
        name : 'PUB_MCP_CR_003',
        component: () => import('@/views/publish/cp/MCP_CR_003.vue')
    },
    
    {
        path: "/publish/gridTest1", 
        name : 'gridTest1',
        component: () => import('@/views/publish/test/DataGridTest.vue')
    },
    
    {
        path: "/publish/gridTest2", 
        name : 'gridTest2',
        component: () => import('@/views/publish/test/DataGridTest2.vue')
    },



]

export {pubCompanyRouter}